// @flow
import {
    GENERAL_REGIONAL,
    GENERAL_REGIONAL_SUCCESS,
    GENERAL_REGIONAL_FAILED,
    GENERAL_REGIONAL_SAVE
} from '../../../constants/actionTypes';

const INIT_STATE = {
    loading: false,
    regional: null
};

type GeneralAction = { type: string, payload: {} | string };
type State = { loading?: boolean, +value?: boolean, regional?: {} | null, saving?: boolean};

const GeneralRegional = (state:State = INIT_STATE, action: GeneralAction) => {
    switch (action.type) {
        case GENERAL_REGIONAL:
            return { ...state, loading: true };
        case GENERAL_REGIONAL_SAVE:
            return { ...state, saving: true };
        case GENERAL_REGIONAL_SUCCESS:
            return { ...state, regional: action.payload, loading: false, saving: false, error: null };
        case GENERAL_REGIONAL_FAILED:
            return { ...state, error: action.payload, loading: false, saveing: false };
        default: return { ...state };
    }
}

export default GeneralRegional;